module.exports = __webpack_public_path__ + "img/逆时针旋转90度3.09127465.svg";